/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { updateProfile } from '../../config/updateProfile.config';

import axios from 'axios';
import { Graphql } from '@common/graphql';
import { GET_TIMELINE } from '../../api/graphql';
import { vappContainer } from '@/application';
import { apiConfig } from '@/config/apiConfig';
import { toHeaderCase } from 'js-convert-case';
import { config } from '../../config/featuresSection.config';
import { StorageModule } from '@vlinder-web/storage-module-react';
import { AppNavigatorService } from '@/AppNavigator';
import { useApplication, useStatus } from '../provider';
import moment from 'moment';

export interface IGetProfileMethods extends IPluginMethodMap {
  getTimeLine(args: any): Promise<any>;
}

const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export class GetProfileService implements IAgentPlugin {
  readonly methods: IGetProfileMethods;

  constructor() {
    this.methods = {
      getTimeLine: this.getTimeLine.bind(this),
    };
  }

  async getTimeLine(args: any) {
    let gql = Graphql.withBaseUrl(apiConfig?.gql?.url);
    const token = loginSrv()?.getToken();
    if (token) {
      gql = gql.withHeaders({
        authentication: token,
      });
    }
    const client = gql.getClient();
    const { applicationNo, credentialNo } = useApplication();

    const storageSrv = StorageModule.getInstance();
    const _localData = storageSrv.get('userProfile', 'local');
    const _sessionData = storageSrv.get('userProfile', 'session');
    const userData = _sessionData ?? _localData;

    console.log('data in query', args);
    try {
      if (client) {
        console.log(client);
        const res = await client
          .query(GET_TIMELINE, {
            input: {
              where: [
                {
                  column: 'display',
                  op: 'Equal',
                  value: true,
                },
                {
                  column: 'txnSetId',
                  value: [applicationNo ?? credentialNo],
                  op: 'Equal',
                },
                {
                  column: 'type',
                  op: 'Equal',
                  value: [applicationNo ? 'APPLICATION' : 'CREDENTIAL'],
                },
              ],
              order: [
                {
                  direction: 'DESC',
                  column: 'when',
                },
              ],
            },
          })
          .toPromise();
        console.log('profileress->', res);
        if (res?.data?.getTxnList) {
          return {
            data: this.formatData(res?.data?.getTxnList?.data),
          };
        }
      }
    } catch (err: any) {
      throw err;
    }
  }
  private getHeadLine(item: any) {
    if (item?.payload?.status) {
      if (item?.payload?.status === 'CREDENTIAL_DOES_NOT_EXIST') {
        return 'E-Certificate not issued';
      }
      return item?.payload?.status;
    }
  }

  private getHeadLine1(item: any) {
    switch (item?.action) {
      case 'APP_SAVED':
        return 'Application Saved';
      case 'APP_STATUS_CHANGED':
        return 'Status Changed';
      case 'APP_INFO_REQUESTED':
        return 'Addition Info Requested';
      case 'APP_SUBMITTED':
        return 'Application Submitted';
      case 'PAYMENT_FAILED':
        return 'Payment Failed';
      case 'PAYMENT_RECEIVED':
        return 'Payment Received';
      case 'PROFILE_UPDATED':
        return 'Payment Updated';
      case 'PROFILE_COMPLETED':
        return 'Profile completed';
      case 'PROCESSING_OFFICER_SUPERVISOR_REVIEW':
        return 'Processng officer supervisor review';
      case 'PROCESSING_OFFICER_REVIEW':
        return 'Processng officer supervisor review';
      case 'DOCUMENTATION_REJECTED':
        return 'Documentation Rejected';
      case 'MINISTRY_REVIEW':
        return 'Ministry Review';
      case 'MISSING_INFORMATION':
        return 'Missing Information';
      case 'DIRECTOR_REVIEW':
        return 'Director Review';
      case 'DIRECTOR_REVIEW_INVESTIGATION':
        return 'Director Review Investigation';
      case 'COMMITEE_REVIEW_INVESTIGATION':
        return 'Committe Review Investigation';
      case 'COMMITEE_REVIEW':
        return 'Committe Review';
      case 'MINISTER_REVIEW_INVESTIGATION':
        return 'Minister Review Investgation';
      case 'MINISTER_REVIEW':
        return 'Minister Review';
      case 'COMPLIANCE_CHECK_AND_SCHEDULE_DATE':
        return 'Compliance Check and Schedule Date';
      case 'COMPLIANCE_CHECK':
        return 'Compliance Check';
      case 'PICA_SCHEDULE_DATE':
        return 'Pica Schedule Date';
      case 'COMPLIANCE_ISSUE_DIRECTOR_REVIEW':
        return 'Compliance Issue Director Review';
      case 'COMPLIANCE_ISSUE_RETURN_TO_PICA':
        return 'Compliance Issue Return to PICA';
      case 'PASSPORT_AFFIXED':
        return 'Passport Affixed';
      case 'PASSPORT_DISTRIBUTED':
        return 'Passport Distributed';
      case 'APPLICATION_DENIED':
        return 'Application Denied';
      case 'APPLIACTION_APPROVED':
        return 'Application Approved';
      default:
        return 'Action';
    }
  }
  private formatCreatedDate = (date: Date) => {
    if (date) {
      return moment(date).format('LLL');
    }
  };
  private formatData(data: any[]) {
    console.log(data, 'l-->22');
    let prevStatus = '';
    let ans: any[] = [];
    for (let i = 0; i < data.length; i++) {
      const item = data[i];
      const childdata = [];
      // if (item?.performedBy) {
      //   item?.performedBy?.firstName &&
      //     childdata.push({
      //       key: 'string',
      //       title: 'Performed By',
      //       subTitle:
      //         (item?.performedBy?.lastName || ' ') +
      //         (item?.performedBy?.middleName || ' ') +
      //         (item?.performedBy?.firstName || ''),
      //       icon: 'https://i.ibb.co/3zKNHvT/user.png',
      //     });
      // }
      if (item?.payload) {
        console.log('itempayload-->', item?.payload);
        item?.payload?.amount &&
          childdata.push({
            key: 'string',
            title: 'Amount',
            subTitle: item?.payload?.amount,
            icon: 'https://i.ibb.co/YkxTbKt/money.png',
          });
        item?.payload?.currency &&
          childdata.push({
            key: 'string',
            title: 'Currency',
            subTitle: item?.payload?.currency,
            icon: 'https://i.ibb.co/G0vWg5N/different-currencies.png',
          });
        // item?.payload?.paidFor &&
        //   childdata.push({
        //     key: 'string',
        //     title: 'Paid for',
        //     subTitle: item?.payload?.paidFor,
        //     icon: 'https://i.ibb.co/Vtvpc8n/money-1.png',
        //   });
        item?.payload?.lastModified &&
          childdata.push({
            key: 'string',
            title: 'Last Modified',
            subTitle: item?.payload?.lastModified,
            icon: 'https://i.ibb.co/3TWvmfk/timetable.png',
          });
        item?.payload?.reason &&
          childdata.push({
            key: 'string',
            title: 'Terminated Reason',
            subTitle: item?.payload?.reason,
            icon: 'https://i.ibb.co/N9pp4kp/help.png',
          });
        item?.payload?.comment &&
          childdata.push({
            key: 'string',
            title: 'Comment',
            subTitle: item?.payload?.comment,
            icon: 'https://i.ibb.co/Qcy2GpM/chat.png',
          });
        item?.payload?.appointment &&
          childdata.push({
            key: 'string',
            title: 'Scheduled date',
            subTitle: this.formatCreatedDate(item?.payload?.appointment),
            icon: 'https://i.ibb.co/qN7m6XB/calendar.png',
          });
        // item?.payload?.applicationNo &&
        //   childdata.push({
        //     key: 'string',
        //     title: 'Application No',
        //     subTitle: item?.payload?.applicationNo,
        //     icon: 'https://i.ibb.co/m0wqGF3/google-forms.png',
        //   });
        ans.push({
          key: item?.when,
          headline: this.getHeadLine1(item),
          headlineBackgroundColor: '#00497A',
          children: [
            {
              itemId: '1',
              title: this.getHeadLine(item),
              subtitle: item?.when
                ? moment(new Date(item?.when)).format('LLL').toString() + ' GMT'
                : '-',
              carouselStyles: {
                width: '250px',
                height: '250px',
              },
              multiColList:
                childdata?.length > 0
                  ? {
                      data: childdata?.length > 0 ? childdata : null,
                      numberOfColumns: childdata?.length > 1 ? '2' : '1',
                    }
                  : null,
            },
          ],
        });
        prevStatus = item?.payload?.status;
      }
    }
    console.log(ans, 'l-->');
    return ans;
  }

  private getAccordionItems(txList: any) {
    let items: any = [];
    if (txList?.length > 0) {
      let timelineDetails = this._getTimeLine(txList);
      items.push({
        type: 'timeline',
        title: config?.timelineDetails?.title,
        data: [...timelineDetails],
        lineColor: '#00497A',
        horizontalStepperColors: {
          DONE: '#00497A',
          UNDONE: '#00497A',
          LAST: '#00497A',
          CURRENT: '#00497A',
        },
      });
    }
    return items;
  }

  private _getTimeLine(data: any) {
    let _temp: any = [];
    Array.isArray(data) &&
      data?.forEach((element) => {
        _temp.push({
          key: element?.id,
          headline: toHeaderCase(element?.action ?? ''),
          headlineBackgroundColor: '#00497A',
          children: this.getChildren(element),
        });
      });

    return _temp;
  }

  private getChildren(data: any) {
    let _temp: any = [];
    _temp.push({
      itemId: data?.id,
      multiColList: this.getProvenanceAccordion(data),
      title: toHeaderCase(data?.action ?? ''),
      subtitle: data?.when ? moment(parseInt(data?.when)).format('LLL') : null,
    });

    return _temp;
  }

  private getProvenanceAccordion(res: any) {
    let _temp: any = [];
    if (res) {
      let _list: any = [];
      let _date: any = [];
      let _location: any = [];
      if (res?.performedBy?.firstName) {
        _list.push({
          title: toHeaderCase('by'),
          subTitle: `${toHeaderCase(
            res?.performedBy?.firstName
          )} ${toHeaderCase(res?.performedBy?.lastName)}`,
          icon: config?.orgIcon,
        });
      }
      if (res?.location) {
        _location.push({
          title: toHeaderCase('at'),
          subTitle: res?.location ?? '-',
          icon: config?.locationIcon,
        });
      }
      if (res?.when) {
        _date.push({
          title: toHeaderCase('on'),
          subTitle: res?.when ? moment(parseInt(res?.when)).format('LLL') : '-',
          icon: config?.dateIcon,
        });
      }
      _temp = [..._list, ..._location, ..._date];
    }
    return {
      numberOfColumns: '2',
      data: _temp,
    };
  }
}
